export default __webpack_public_path__ + "static/media/washerdryer1.c236049c.png";